import type { ReactNode } from 'react'

import { cx } from './cx.ts'

import './badge.css'

/**
 * 귀속 배지 — 와이어프레임 `.badge` CSS 196행 · `attribution()` 1068행.
 * 모니터링 카드가 쓴다. `inconclusive` = 점선 「판정 불가」.
 *
 * ⚠ IDLE 은 배지를 아예 그리지 않는다(07 §2.8 ⓑ). 빈 배지를 만들지 마라 —
 *   호출부에서 조건부로 렌더한다.
 */
export type BadgeProps = {
  children: ReactNode
  variant?: 'default' | 'inconclusive' | undefined
}

export function Badge({ children, variant = 'default' }: BadgeProps) {
  return (
    <span className={cx('a-badge', variant !== 'default' && `a-badge--${variant}`)}>
      {children}
    </span>
  )
}
